<template>
    <b-modal id="role_assign" ref="role_assign" @hidden="resetModal"
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            Assign Permisssions
        </template>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-checkbox v-model="toggle_all" @input="toggleAll" class="mb-3">
                        <h3>Toggle All</h3>
                    </b-form-checkbox>
                </b-colxx>
            </b-row>

            <b-row>
<!--                <b-form-checkbox-group-->
<!--                    name="permissions"-->
<!--                    v-model="selected"-->
<!--                    :options="permissions.data"-->
<!--                    text-field="label"-->
<!--                    value-field="data"-->
<!--                    @input="pushPermission($event)"-->
<!--                />-->



                <b-colxx md="3" v-for="permission in permissions.data" :key="permission.permission_id">
                    <b-form-checkbox :key="permission.permission_id" v-model="selected" :value="permission" @input="pushPermission(permission)">
                        {{ permission.data.attributes.name }}
                    </b-form-checkbox>
                </b-colxx>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "RolePermissionModal",

    components: {

    },

    data() {
        return {
            toggle_all: false,
            selected: [],
        }
    },

    computed: {
        ...mapGetters({
            form: 'getRolePermissionForm',
            errors: 'getRoleErrors',
            permissions: 'getPermissions',
        }),
    },

    methods: {
        resetModal() {
            this.$emit('close');
            this.$store.commit('setRolePermissionForm');
        },

        toggleAll(checked) {
            if (checked) {
                this.form.names = this.permissions.data.map(permission => {
                    return permission.data.attributes.name;
                });
            } else {
                this.form.names  = [];
            }
        },

        pushPermission(permission) {
            console.log(this.selected);
            if (permission.checked) {
                this.form.names.push(permission.data.attributes.name);
            } else {
                this.form.names = this.form.names.filter(name => {
                    return name !== permission.data.attributes.name;
                });
            }
        }
    }
}
</script>

<style scoped>

</style>
